import { axios as api } from '@/plugins/axios';
import { TokenService } from '../token';

const tokenService = new TokenService();

export class AuthService {
  endpoint: string;
  constructor() {
    this.endpoint = '/v1/accounts/';
  }
  async login(email: string, password: string): Promise<any> {
    return api
      .post(
        `${this.endpoint}auth/login/`,
        {
          email: email,
          password: password
        },
        {
          headers: {
            Authorization: null
          }
        }
      )
      .then(({ data }) => {
        // TODO look into setting Authorization header some selected requests
        api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        tokenService.setToken(data.token); //TODO: check logic for login as it seems to set token in service and also in store
        data.tokenData = tokenService.decodeToken(data.token);
        return data;
      });
  }

  async refreshToken(token: string): Promise<any> {
    return api
      .post(`${this.endpoint}auth/token-refresh/`, { token: token })
      .then(({ data }) => {
        api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        data.tokenData = tokenService.decodeToken(data.token);
        tokenService.setToken(data.token, data.tokenData);
        return data;
      });
  }

  async verifyEmail(email: string): Promise<any> {
    return api
      .post(
        `${this.endpoint}auth/request-email/`,
        { email: email },
        {
          headers: {
            Authorization: null
          }
        }
      )
      .then(({ data }) => data);
  }
  async forgotPassword(email: string): Promise<any> {
    return api
      .post(
        `${this.endpoint}auth/password/reset/`,
        { email: email },
        {
          headers: {
            Authorization: null
          }
        }
      )
      .then(({ data }) => data);
  }
  async passwordConfirm(uid: string, token: string): Promise<any> {
    return api
      .get(`${this.endpoint}auth/password-reset/confirm/${uid}/${token}/`, {
        headers: {
          Authorization: null
        }
      })
      .then(({ data }) => data);
  }
  async passwordResetConfirm(payload: any): Promise<any> {
    return api
      .post(
        `${this.endpoint}auth/password/reset/confirm/`,
        {
          new_password1: payload.password1,
          new_password2: payload.password2,
          uid: payload.uid,
          token: payload.token
        },
        {
          headers: {
            Authorization: null
          }
        }
      )
      .then(({ data }) => data);
  }

  async confirmEmail(key: string) {
    api
      .get(`${this.endpoint}registration/account-confirm-email/${key}/`, {
        headers: {
          Authorization: null
        }
      })
      .then(({ data }) => data);
  }

  async logout() {
    api
      .post(`${this.endpoint}auth/logout/`, undefined, {
        headers: {
          Authorization: null
        }
      })
      .then(({ data }) => {
        delete api.defaults.headers.common['Authorization'];
        return data;
      });
  }
}
